export default __webpack_public_path__ + "static/media/marketplace_bg.535d2d4a.png";